/* eslint-disable no-unused-vars */
// import axios from "axios";
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
} from "../apiHandler";
import { isEmptyObj } from "../../utils/helper";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });

export default class TicketingSystem {
  static createTicket(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/ticketing/applications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    TicketingSystem.createTicket.cancel = request.cancel;
    return request;
  }

  static getTicket({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/ticketing/applications", {
      accessToken: accessTokenFromLocal,
      data,
    });

    TicketingSystem.getTicket.cancel = request.cancel;
    return request;
  }

  static getTicketById(id) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/ticketing/applications/${id}`, {
      accessToken: accessTokenFromLocal,
    });

    TicketingSystem.getTicketById.cancel = request.cancel;
    return request;
  }

  static getRemarksData({ id }) {
    const accessToken = localStorage.getItem("authToken");
    const request = get(`/api/ticketing/applications/${id}/remarks`, {
      accessToken,
    });

    TicketingSystem.getRemarksData.cancel = request.cancel;
    return request;
  }

  static updateTicket(data, { id }) {
    const accessToken = localStorage.getItem("authToken");
    const request = put(`/api/ticketing/applications/${id}`, {
      accessToken,
      data,
    });

    TicketingSystem.updateTicket.cancel = request.cancel;
    return request;
  }

  static uploadAttachments({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const request = post(`/api/ticketing/uploadFile`, {
      accessToken: accessTokenFromLocal,
      data,
      headers,
    });

    TicketingSystem.uploadAttachments.cancel = request.cancel;
    return request;
  }

  static getModuleName() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/masters/modules", {
      accessToken: accessTokenFromLocal,
    });

    TicketingSystem.getModuleName.cancel = request.cancel;
    return request;
  }

  static getTicketAssignee() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/members/ticketing/assignee", {
      accessToken: accessTokenFromLocal,
    });

    TicketingSystem.getTicketAssignee.cancel = request.cancel;
    return request;
  }
}
